import React, { type RefObject } from 'react';
import { type UserReferenceObject } from '../types';
import classnames from 'classnames';
import styles from '../../../Reference.module.css';

function getMenuItemComponent(showAvatar = false) {
  return React.forwardRef<HTMLElement | null, any>(
    function menuItemComponentWithRef(
      { item, selected }: { item: UserReferenceObject; selected: boolean },
      ref
    ) {
      const {
        name,
        email,
        type = '',
        avatar_url: avatarUrl,
        duplicate_name: duplicateName,
      } = item;

      const containerClassName = classnames({
        [styles.searchComponent]: true,
        [styles.selected]: selected,
      });

      const styledEmail = duplicateName ? ` (${email})` : '';
      const typeContent = type ? (
        <div className={styles.searchComponent__subtext}>{type}</div>
      ) : null;

      const avatarClassName = `reference-item-${item.class
        .toLowerCase()
        .replace('::', '-')}`;

      return (
        <div
          className={containerClassName}
          ref={ref as RefObject<HTMLDivElement>}
        >
          {showAvatar && (
            <aha-avatar
              name={name}
              size={type ? 24 : 16}
              class={avatarClassName}
              src={avatarUrl}
            />
          )}
          <div className={styles.searchComponent__content}>
            {name}
            {styledEmail}
            {typeContent}
          </div>
        </div>
      );
    }
  );
}

export default getMenuItemComponent;
